"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castellero": {
    "5fabddf1": [{
      "hkey": "c3d51317",
      "slug": "castellero",
      "name": "Castellero",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-bordone": [{
      "hkey": "c3d51317",
      "slug": "castellero",
      "name": "Castellero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e155e669": [{
      "hkey": "c3d51317",
      "slug": "castellero",
      "name": "Castellero",
      "primary": true,
      "skipSearch": false
    }],
    "bricco": [{
      "hkey": "c3d51317",
      "slug": "castellero",
      "name": "Castellero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce93ee14": [{
      "hkey": "c3d51317",
      "slug": "castellero",
      "name": "Castellero",
      "primary": true,
      "skipSearch": false
    }],
    "trucco": [{
      "hkey": "c3d51317",
      "slug": "castellero",
      "name": "Castellero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c167ad0": [{
      "hkey": "554b5867",
      "slug": "valporino",
      "name": "Valporino",
      "primary": true,
      "skipSearch": false
    }],
    "vaporino": [{
      "hkey": "554b5867",
      "slug": "valporino",
      "name": "Valporino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9d8207c1": [{
      "hkey": "c3d51317",
      "slug": "castellero",
      "name": "Castellero",
      "primary": true,
      "skipSearch": false
    }],
    "vernetto": [{
      "hkey": "c3d51317",
      "slug": "castellero",
      "name": "Castellero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;